<mat-card class="card-password">
  <div class="font-extrabold text-2xl text-center">
    Existe tarifário com esse trecho.
  </div>
  <div class="flex flex-col justify-around items-center mt-5 -mx-2 gap-4">
    <button mat-flat-button class="btn-tg-cancel dialog-btn" (click)="response('cancelar')">
      Cancelar criação
    </button>
    <button mat-flat-button class="btn-tg-white dialog-btn" (click)="response('devolver')">
      Devolver para proposta
    </button>
    <button mat-flat-button class="btn-tg dialog-btn" (click)="response('substituir')">
      Criar outro tarifário mesmo assim
    </button>
  </div>
</mat-card>
